import React from "react";
import Section from "./section";
import { IRealtimeData } from "../../../../types";
import RtValue from "./rtValue";
import { ICastingFloorCodes } from "./types";

interface IProps {
  realtime:  Record<string, IRealtimeData>;
}


const codes: ICastingFloorCodes = {
  ladleTurret: {
    a1Weight: "MS.CASTER1.TURRET.A1.GROSS_WEIGHT",
    a2Weight: "MS.CASTER1.TURRET.A2.GROSS_WEIGHT"
  },
  tundish: {
    netWeight: "MS.CASTER1.TUNDISH.NET_WEIGHT",
    tareWeight: "MS.CASTER1.TUNDISH.TARE_WEIGHT",
    grossWeight: "MS.CASTER1.TUNDISH.GROSS_WEIGHT",
    sp: "MS.CASTER1.TUNDISH.STEEL_WEIGHT_SP",
    totalTonCast: "MS.CASTER1.TUNDISH.TOTAL_TON_CAST"
  },
  currentHeat: {
    actual: "MS.CASTER1.HEAT.ACTUAL",
    grade: "MS.CASTER1.HEAT.ACTUAL_GRADE"
  }
};


const CastingFloor = ({ realtime }: IProps) => {

  return (
    <Section title="Casting Floor" level={0}>
      <div className="display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr" }}>
        <Section title="Ladle Turret [s. ton]" level={0}>
          <div className="display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr" }}>
            <RtValue orientation="vertical" title="AIM" rtValue={realtime[codes.ladleTurret.a1Weight]}
                     style={{ color: "green", textAlign: "center", fontSize: "2em" }} />
            <RtValue orientation="vertical" title="AIM" rtValue={realtime[codes.ladleTurret.a2Weight]}
                     style={{ color: "green", textAlign: "center", fontSize: "2em" }} />
          </div>
        </Section>
        <Section title="Current Heat" level={0}>
          <div className="display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr" }}>
            <RtValue orientation="vertical" title="Heat" rtValue={realtime[codes.currentHeat.actual]}
                     style={{ color: "green", textAlign: "center", fontSize: "2em" }} />
            <RtValue orientation="vertical" title="Grade" rtValue={realtime[codes.currentHeat.grade]}
                     style={{ color: "green", textAlign: "center", fontSize: "2em" }} />
          </div>
        </Section>
        <Section title="Tundish in Casting [s. ton]" level={0} style={{ gridColumn: "1/3" }}>
          <div className="display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr" }}>
            <div className="display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr" }}>
              <RtValue orientation="vertical" title="Tare Weight" rtValue={realtime[codes.tundish.tareWeight]}  decimals={1}
                       style={{ color: "green", textAlign: "center", fontSize: "2em" }} />
              <RtValue orientation="vertical" title="Gross Weight" rtValue={realtime[codes.tundish.grossWeight]}  decimals={1}
                       style={{ color: "green", textAlign: "center", fontSize: "2em" }} />
              <RtValue orientation="vertical" title="Net Weight" rtValue={realtime[codes.tundish.netWeight]}  decimals={1}
                       style={{ color: "green", textAlign: "center", fontSize: "2em" }} />
              <RtValue orientation="vertical" title="SP" rtValue={realtime[codes.tundish.sp]} decimals={1}
                       style={{ color: "blue", textAlign: "center", fontSize: "2em" }} />

            </div>
            <RtValue orientation="vertical" title="Total Ton Cast" rtValue={realtime[codes.tundish.totalTonCast]}  decimals={1}
                     style={{ color: "green", textAlign: "center", fontSize: "3em" }} />
          </div>
        </Section>
      </div>
    </Section>
  );
}

export default CastingFloor;